import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { authActions } from '../app/store/actions';
import { RootState } from '../app/store/store';
import { useAuthSync } from '../hooks/useAuthSync';
import { useRedirectPath } from '../hooks/useRedirectPath';
import { Spinner } from '../components/Loaders';

const Root = () => {
  const user = useSelector((state: RootState) => state.Auth.user);
  const dispatch = useDispatch();
  const { redirectPath, isLoading } = useRedirectPath();

  // Sync authentication state with Redux
  useAuthSync(user, dispatch, authActions.logout);

  if (isLoading) {
    return <Spinner color="primary" />;
  }

  return <Redirect to={`/${redirectPath}`} />;
};

export default Root;
